import { customReservedInventoryBucketTypeIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const createCustomReservedInventoryBucketType = {
  name: "createCustomReservedInventoryBucketType" as const,
  input: z.object({ name: z.string().min(1) }),
  output: z.object({ id: customReservedInventoryBucketTypeIdFormat.schema }),
};
